import { ReactComponent as CalendarIcon } from "../../../../../assets/utils/images/svgs/calendar-blue.svg";
import { Input, Label } from "reactstrap";
import ControlSelectCell from "./Partials/ControlSelectCell";
import moment from "moment";

export const dataList = [
	{
		label: "Label",
		value: "Value",
	},
	{
		label: "Label",
		value: "Value",
	},
];

export const memoFields = [
	{ label: "Memo door vervanger", path: "note" },
	{ label: "Memo Contracttype", path: "contract.note" },
	{ label: "Memo bestuur vervanger", path: "community.note" },
];

export const docFields = [
	{ label: "VOG:", path: "data.vog" },
	{ label: "ID:", path: "data.pass" },
	{ label: "Diploma:", path: "data.pabo" },
	{ label: "36 maanden:", path: "data.d36mnd" },
	{ label: "Begin blokkeerdatum controle:", path: "data.beginBlock" },
	{ label: "Eind blokkeerdatum controle:", path: "data.endBlock" },
	{ label: "Datum contracttype verlopen:", path: "data.expiredContractType" },
	{ label: "Ketenregeling tellerstand:", path: "data.keten" },
];

export const getCardFieldsArray = (fields, userData, includeEmpty = true) => {
	return fields
		.map(({ label, path }) => {
			const value = path.split(".").reduce((obj, key) => obj?.[key], userData);
			return {
				label,
				value: value ? value : "-",
			};
		})
		.filter(
			({ value }) =>
				includeEmpty ||
				(value !== "-" && value !== null && value !== undefined && value !== "")
		);
};

export const getDateElement = (name, date) => {
	return (
		<div className="d-flex gap-2 align-items-center">
			<span className="fw-bold">{name}</span>
			{date}
			<CalendarIcon />
		</div>
	);
};

export const getCheckboxElement = (checked, setChecked, label = "", id = "") => {
	return (
		<div className="d-flex gap-2">
			<Input
				type="checkbox"
				id={id}
				className="planscreen__checkbox m-0"
				checked={checked}
				onChange={() => setChecked(!checked)}
			/>
			{label && <Label for={id}>{label}</Label>}
		</div>
	);
};

export const days = ["ma", "di", "wo", "do", "vr"];
export const shifts = ["Ochtend", "Middag"];

export function generateControlTableColumns(availabilityData) {
	return availabilityData.map((shiftObj) => ({
		header: shiftObj.shift,
		columns: shiftObj.days.map((dayObj, index) => ({
			header: dayObj.name,
			id: `${shiftObj.shift.toLowerCase()}-${index}`,
			accessorFn: (row) => {
				const dayIndex = shiftObj.shift === shifts[0] ? 0 : 1;
				const item = row[dayIndex]?.days.find((d) => {
					return d.name === dayObj.name;
				});
				return item ?? null;
			},
			cell: ControlSelectCell,
		})),
	}));
}

export const availabilityValues = ["+", "!", "-", "x", "i", "I"];

export function findFirstAndLastOpenDates(dates) {
	if (!Array.isArray(dates)) return [null, null];

	const result = [];

	function getFirstInstance(dates) {
		if (!Array.isArray(dates)) return null;

		return (
			dates.find((entry) => {
				const shiftStatuses = Object.values(entry.data ?? {}).map((shift) =>
					shift?.status?.toLowerCase()
				);

				return shiftStatuses.some((status) => status == "openstaand");
			}) ?? null
		);
	}

	result.push(getFirstInstance(dates));
	const reversedDates = [...dates].reverse();
	result.push(getFirstInstance(reversedDates));

	return result;
}

export function getSelectedDaysIds(dates) {
	if (!Array.isArray(dates)) return [];
	const selectedIds = [];

	dates.forEach((entry) => {
		const shiftData = entry.data;

		Object.values(shiftData).forEach((shift) => {
			if (shift && shift.id && shift.isSelected) {
				selectedIds.push(shift.id);
			}
		});
	});

	return selectedIds;
}
export const isCurrentOrFutureWeek = (dateStr) => {
	const date = moment(dateStr, "DD-MM-YYYY");
	const current = moment();

	if (date.year() > current.year()) return true;
	if (date.year() === current.year() && date.isoWeek() >= current.isoWeek()) return true;

	return false;
};

export const checkHasUpcomingDays = (dates) => {
	return dates.some(({ day, data }) => {
		if (!isCurrentOrFutureWeek(day)) return false;
		return Object.values(data).some((shift) => shift.status === "Openstaand");
	});
};
